import { useEffect, useState } from "react";

/** Whether a media query matches, following it as the window changes. */
export function useMediaQuery(q: string): boolean {
  const [m, setM] = useState(() => typeof window !== "undefined" && window.matchMedia(q).matches);
  useEffect(() => {
    const mq = window.matchMedia(q);
    const on = () => setM(mq.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [q]);
  return m;
}

/** The desk layout: course bar, side-by-side panels, two-month calendars. */
export const useWide = () => useMediaQuery("(min-width: 900px)");
